import AxiosClient from "../../../services/axios.services";

class PlansServices {
  getPlan = (params) =>
    AxiosClient.get(
      "/api/app/carrera_plan/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getPlanByID = (id) =>
    AxiosClient.get(
      `/api/app/carrera_plan/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  savePlan = (data) =>
    AxiosClient.post(
      "/api/app/carrera_plan_plan_accion/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editPlan = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_plan/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editPlanAccion = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_plan_accion/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deletePlan = (id) =>
    AxiosClient.delete(
      `/api/app/carrera_plan/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new PlansServices();
